import { queryOptions } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

export const dashboardSummaryAdminQuery = () => {
  return queryOptions({
    queryKey: ["admin", "dashboard-summary"],
    queryFn: async (): Promise<
      PowerUpServiceResponseBody["dashboardSummaryAdmin"][200]
    > => {
      return handleClientMethod(getClient().GET("/admin/dashboard-summary"));
    },
  });
};
